/* tslint:disable */
/* eslint-disable */
/**
 * My App API
 * My App API description
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ExtendRole
 */
export interface ExtendRole {
    /**
     * 
     * @type {string}
     * @memberof ExtendRole
     */
    role?: ExtendRoleRoleEnum;
    /**
     * 
     * @type {boolean}
     * @memberof ExtendRole
     */
    isTeacher: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof ExtendRole
     */
    isApplicant: boolean;
}

/**
* @export
* @enum {string}
*/
export enum ExtendRoleRoleEnum {
    Aao = 'aao',
    Approve = 'approve',
    Office = 'office'
}

export function ExtendRoleFromJSON(json: any): ExtendRole {
    return ExtendRoleFromJSONTyped(json, false);
}

export function ExtendRoleFromJSONTyped(json: any, ignoreDiscriminator: boolean): ExtendRole {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'role': !exists(json, 'role') ? undefined : json['role'],
        'isTeacher': json['isTeacher'],
        'isApplicant': json['isApplicant'],
    };
}

export function ExtendRoleToJSON(value?: ExtendRole | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'role': value.role,
        'isTeacher': value.isTeacher,
        'isApplicant': value.isApplicant,
    };
}


